import {
  MatchDecorator,
  Decoration,
  ViewPlugin,
  EditorView,
} from "@codemirror/view";
import functions from "./functions";

const regex = new RegExp(
  `\\b(${functions.map((f) => f.value).join("|")})\\b(?=\\()`,
  "g",
);

const functionMatcher = new MatchDecorator({
  regexp: regex,
  decoration: () => {
    return Decoration.mark({ class: "cm-function-highlight" });
  },
});

const functionExtension = ViewPlugin.fromClass(
  class {
    functions;
    constructor(view) {
      this.functions = functionMatcher.createDeco(view);
    }
    update(update) {
      this.functions = functionMatcher.updateDeco(update, this.functions);
    }
  },
  {
    decorations: (instance) => instance.functions,
    provide: (plugin) =>
      EditorView.atomicRanges.of((view) => {
        return view.plugin(plugin)?.functions || Decoration.none;
      }),
  },
);

export default functionExtension;

export const functionHighlightTheme = EditorView.theme({
  ".cm-function-highlight": {
    color: "black",
    fontWeight: "bold",
  },
});
